import { useApiDeleteRequest } from '@/api/rest/hooks/useApiDeleteRequest';
import { useApiPatchRequest } from '@/api/rest/hooks/useApiPatchRequest';
import { useApiPostRequest } from '@/api/rest/hooks/useApiPostRequest';

import {
  DELETE_INDICATOR_PRODUCT_SUBSCRIPTION_CONFIGURATION_PATH,
  DeleteDashboardIndicatorProductSubscriptionConfigurationErrorDto,
  DeleteDashboardIndicatorProductSubscriptionConfigurationRequestPathVariables,
  DeleteDashboardIndicatorProductSubscriptionConfigurationRequestQueryParams,
  DeleteDashboardIndicatorProductSubscriptionConfigurationSuccessDto,
  PATCH_INDICATOR_PRODUCT_SUBSCRIPTION_CONFIGURATION_PATH,
  PatchDashboardIndicatorProductSubscriptionConfigurationBodyData,
  PatchDashboardIndicatorProductSubscriptionConfigurationErrorDto,
  PatchDashboardIndicatorProductSubscriptionConfigurationRequestPathVariables,
  PatchDashboardIndicatorProductSubscriptionConfigurationRequestQueryParams,
  PatchDashboardIndicatorProductSubscriptionConfigurationSuccessDto,
  POST_INDICATOR_PRODUCT_SUBSCRIBE_PATH,
  POST_INDICATOR_PRODUCT_SUBSCRIPTION_CONFIGURATION_FILE_UPLOAD_PATH,
  POST_INDICATOR_PRODUCT_SUBSCRIPTION_CONFIGURATION_PATH,
  PostDashboardIndicatorProductSubscriptionConfigurationBodyData,
  PostDashboardIndicatorProductSubscriptionConfigurationErrorDto,
  PostDashboardIndicatorProductSubscriptionConfigurationFileUploadBodyData,
  PostDashboardIndicatorProductSubscriptionConfigurationFileUploadErrorDto,
  PostDashboardIndicatorProductSubscriptionConfigurationFileUploadRequestPathVariables,
  PostDashboardIndicatorProductSubscriptionConfigurationFileUploadRequestQueryParams,
  PostDashboardIndicatorProductSubscriptionConfigurationFileUploadSuccessDto,
  PostDashboardIndicatorProductSubscriptionConfigurationRequestPathVariables,
  PostDashboardIndicatorProductSubscriptionConfigurationRequestQueryParams,
  PostDashboardIndicatorProductSubscriptionConfigurationSuccessDto,
  PostIndicatorProductSubscribeBodyData,
  PostIndicatorProductSubscribeErrorDto,
  PostIndicatorProductSubscribeRequestPathVariables,
  PostIndicatorProductSubscribeRequestQueryParams,
  PostIndicatorProductSubscribeSuccessDto,
} from './types/IndicatorProduct';

export const useIndicatorProductSubscribe = () => {
  return useApiPostRequest<
    PostIndicatorProductSubscribeRequestPathVariables,
    PostIndicatorProductSubscribeRequestQueryParams,
    PostIndicatorProductSubscribeBodyData,
    PostIndicatorProductSubscribeSuccessDto,
    PostIndicatorProductSubscribeErrorDto
  >(POST_INDICATOR_PRODUCT_SUBSCRIBE_PATH);
};

export const usePostDashboardIndicatorProductSubscriptionConfiguration = () => {
  return useApiPostRequest<
    PostDashboardIndicatorProductSubscriptionConfigurationRequestPathVariables,
    PostDashboardIndicatorProductSubscriptionConfigurationRequestQueryParams,
    PostDashboardIndicatorProductSubscriptionConfigurationBodyData,
    PostDashboardIndicatorProductSubscriptionConfigurationSuccessDto,
    PostDashboardIndicatorProductSubscriptionConfigurationErrorDto
  >(POST_INDICATOR_PRODUCT_SUBSCRIPTION_CONFIGURATION_PATH);
};

export const usePatchDashboardIndicatorProductSubscriptionConfiguration = () => {
  return useApiPatchRequest<
    PatchDashboardIndicatorProductSubscriptionConfigurationRequestPathVariables,
    PatchDashboardIndicatorProductSubscriptionConfigurationRequestQueryParams,
    PatchDashboardIndicatorProductSubscriptionConfigurationBodyData,
    PatchDashboardIndicatorProductSubscriptionConfigurationSuccessDto,
    PatchDashboardIndicatorProductSubscriptionConfigurationErrorDto
  >(PATCH_INDICATOR_PRODUCT_SUBSCRIPTION_CONFIGURATION_PATH);
};

export const useDeleteDashboardIndicatorProductSubscriptionConfiguration = () => {
  return useApiDeleteRequest<
    DeleteDashboardIndicatorProductSubscriptionConfigurationRequestPathVariables,
    DeleteDashboardIndicatorProductSubscriptionConfigurationRequestQueryParams,
    DeleteDashboardIndicatorProductSubscriptionConfigurationSuccessDto,
    DeleteDashboardIndicatorProductSubscriptionConfigurationErrorDto
  >(DELETE_INDICATOR_PRODUCT_SUBSCRIPTION_CONFIGURATION_PATH);
};

export const usePostIndicatorProductSubscriptionConfigurationFileUpload = () => {
  return useApiPostRequest<
    PostDashboardIndicatorProductSubscriptionConfigurationFileUploadRequestPathVariables,
    PostDashboardIndicatorProductSubscriptionConfigurationFileUploadRequestQueryParams,
    PostDashboardIndicatorProductSubscriptionConfigurationFileUploadBodyData,
    PostDashboardIndicatorProductSubscriptionConfigurationFileUploadSuccessDto,
    PostDashboardIndicatorProductSubscriptionConfigurationFileUploadErrorDto
  >(POST_INDICATOR_PRODUCT_SUBSCRIPTION_CONFIGURATION_FILE_UPLOAD_PATH);
};
